import { render, staticRenderFns } from "./ModernBookingIcon.vue?vue&type=template&id=5787e9f2&scoped=true&"
import script from "./ModernBookingIcon.vue?vue&type=script&lang=js&"
export * from "./ModernBookingIcon.vue?vue&type=script&lang=js&"
import style0 from "./ModernBookingIcon.vue?vue&type=style&index=0&id=5787e9f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5787e9f2",
  null
  
)

export default component.exports